import loadable from '@loadable/component';

const AsyncPage = loadable((props: any) => import(`../../${props.location}`), {
  cacheKey: props => props.location,
});

export default AsyncPage;
